var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39342 1.74136C6.0607 2.43678 7.47269 3.85292 8.78526 4.81429C8.78526 4.81429 7.49818 2.66111 5.00151 0C2.5042 2.66111 1.21777 4.81429 1.21777 4.81429C2.53202 3.85168 3.94561 2.43313 4.6119 1.73868L4.6119 7.44344H5.39342L5.39342 1.74136ZM9.10903 6.55868V9.0592H0.893043V6.55868H0V9.61984C0 9.71954 0.0419102 9.81795 0.11429 9.88907C0.18668 9.96082 0.281931 10.0002 0.383519 10.0002H9.57497C9.67592 10.0002 9.81839 9.96082 9.89266 9.88717C9.96188 9.81541 10.0021 9.71572 10.0021 9.61983V6.55868H9.10903Z",
    fill: "#116F9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.17f785ef6d89882d433cde1b469142ef.svg";
export { ForwardRef as ReactComponent };